import { useEffect, useState, useCallback, useRef } from 'react'
import { ProgressBar } from 'devextreme-react/progress-bar'
import { socketGet } from '../../socket'
import { saveAs } from 'file-saver'
import axios from 'axios'

import './export-progress.scss'

export default function ExportProgress() {
	const [exportPercent, setExportPercent] = useState(-1)
	const mine = useRef(false)

	const socket = socketGet()
	useEffect(() => {
		const onActive = (e: Event) => {
			mine.current = (e as CustomEvent<boolean>).detail
		}

		const handlerStarted = () => {
			if (!mine.current) return
			setExportPercent(0)
		}
		const handlerFinished = async (payload: any) => {
			if (!mine.current) return
			const { hash, file } = payload
			mine.current = false
			setExportPercent(100)

			try {
				const response = await axios({
					method: 'get',
					url: `${API_FIBER_URL}/exports/file/${encodeURIComponent(hash)}/download?auto=true`,
					responseType: 'blob',
				})
				const { data, headers } = response
				saveAs(new Blob([data], { type: headers['content-type'] }), file)
			} finally {
				setTimeout(() => setExportPercent(-1), 3000)
			}
		}
		const handlerProgress = (data: any) => {
			if (!mine.current) return
			setExportPercent(data.percent)
		}
		const handlerError = () => {
			if (!mine.current) return
			mine.current = false
			setExportPercent(-1)
		}

		window.addEventListener('artemis-export', onActive)
		if (socket) {
			socket.on('legacy_export_started', handlerStarted)
			socket.on('legacy_export_finished', handlerFinished)
			socket.on('legacy_export_progress', handlerProgress)
			socket.on('legacy_export_error', handlerError)
		}

		return () => {
			window.removeEventListener('artemis-export', onActive)
			if (socket) {
				socket.off('legacy_export_started', handlerStarted)
				socket.off('legacy_export_finished', handlerFinished)
				socket.off('legacy_export_progress', handlerProgress)
				socket.off('legacy_export_error', handlerError)
			}
		}
	}, [socket])

	const statusFormat = useCallback(() => {
		if (exportPercent === 100) {
			return 'Completed [ 100% ]'
		}
		return 'Exporting [ ' + exportPercent + '% ]'
	}, [exportPercent])

	if (exportPercent === -1) {
		return null
	}

	return (
		<div className="export-progress-container slide-down">
			<div className="export-progress-content">
				<ProgressBar
					min={0}
					max={100}
					height={20}
					value={exportPercent}
					statusFormat={statusFormat}
					className="export-progress-bar"
				/>
			</div>
		</div>
	)
}
